const util = new window.Util();

function format(num) {
  return num.toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}
export {
  util,
  format
};
